<template>
  <BOverlay :show="isLoading">
    <BRow>
      <BCol cols="12">
        <BCard>
          <div
            class="w-100 mb-3 d-flex align-items-center justify-content-between"
          >
            <h1>کلاس های برگزار شده در روز های هفته</h1>
          </div>
          <FiltersWrapper @submitFilters="setFilters">
            <RangeDatePicker
              class="w-24 filters-width"
              label="بازه‌ی تاریخ جلسات رزرو شده را وارد کنید"
              @getDateRange="setDateRange"
            ></RangeDatePicker>
            <MasterPicker
              class="w-24 filters-width"
              @getMaster="setMasterUserId"
            ></MasterPicker>
            <PriceCategoryPicker
              class="w-24 filters-width"
              @getPriceCategory="setPriceCategoryId"
            ></PriceCategoryPicker>
            <LoyaltyDiscountLevelPicker
              class="w-24 filters-width"
              @getLoyaltyDiscountId="setLoyaltyDiscountId"
            ></LoyaltyDiscountLevelPicker>
            <LanguagePicker
              class="w-24 filters-width"
              @getLanguage="setLanguageId"
            ></LanguagePicker>
          </FiltersWrapper>
          <div class="my-2">
            <BRow>
              <BCol cols="12">
                <general-line-chart
                  ref="chart"
                  :getChartData="getWeekChartData"
                ></general-line-chart>
              </BCol>
            </BRow>
          </div>
        </BCard>
      </BCol>
    </BRow>
  </BOverlay>
</template>
<script>
export default {
  data() {
    return {
      isLoading: false,
      mostScheduleCountFilters: {
        pageNumber: 1,
        count: 50,
        fromDate: null,
        toDate: null,
        masterUserId: null,
        priceCategoryId: null,
        sexuality: null,
        fromBirthDate: null,
        toBirthDate: null,
        countryId: null,
        cityId: null,
        jobId: null,
        scheduleLoyaltyDiscountTitleId: null,
        vipUserId: null,
        languageId: null,
        lessonLanguageId: null,
        dayOfWeek: null,
        dayLightType: null,
      },
    };
  },
  methods: {
    setFilters() {
      this.$refs?.chart?.sendChartRequest();
    },
    setLoyaltyDiscountId(loyaltyDiscountId) {
      this.mostScheduleCountFilters.scheduleLoyaltyDiscountTitleId =
        loyaltyDiscountId;
    },
    setLanguageId(languageId) {
      this.mostScheduleCountFilters.languageId = languageId;
    },
    setMasterUserId(master) {
      this.mostScheduleCountFilters.masterUserId = master
        ? master.userId
        : null;
    },
    setChartType(chartType) {
      this.mostScheduleCountFilters.type = chartType;
    },
    setPriceCategoryId(priceCategoryId) {
      this.mostScheduleCountFilters.priceCategoryId = priceCategoryId;
    },
    setPriceCategory(priceCategoryId) {
      this.mostScheduleCountFilters.priceCategoryId = priceCategoryId;
    },
    setDateRange(dateRange) {
      if (dateRange && dateRange.length > 0) {
        this.mostScheduleCountFilters.fromDate = new Date(
          dateRange[0]
        ).toISOString();
        this.mostScheduleCountFilters.toDate = new Date(
          dateRange[1]
        ).toISOString();
      } else {
        this.mostScheduleCountFilters.fromDate = null;
        this.mostScheduleCountFilters.toDate = null;
      }
    },
    async getWeekChartData(_this) {
      try {
        let getMostSchaduleCountByDayOfWeek =
          new GetMostSchaduleCountByDayOfWeek(_this);
        getMostSchaduleCountByDayOfWeek.setRequestParamDataObj(
          this.mostScheduleCountFilters
        );
        await getMostSchaduleCountByDayOfWeek.fetch((res) => {
          _this.chartOptions.series = [];
          if (res.length > 0) {
            let myDataArray = [];
            let myLabelArray = [];
            if (res.length > 0) {
              res.forEach((item) => {
                myLabelArray.push(item.title);
                myDataArray.push(item.value);
              });
              _this.chartOptions.series.push({
                data: myDataArray,
              });
              _this.chartOptions["xaxis"]["categories"] = myLabelArray;
              _this.isRenderingChart = true;
            }
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BOverlay,
    FiltersWrapper,
    SearchInput,
    RangeDatePicker,
    PriceCategoryPicker,
    MasterPicker,
    LoyaltyDiscountLevelPicker,
    LanguagePicker,
    DayOfWeekPicker,
    GeneralLineChart,
  },
};
import { BCard, BRow, BCol, BOverlay } from "bootstrap-vue";
import { GetMostSchaduleCountByDayOfWeek } from "@/libs/Api/UserReport";
import FiltersWrapper from "@/views/components/Utils/FiltersWrapper.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import RangeDatePicker from "@/views/components/Utils/RangeDatePicker.vue";
import PriceCategoryPicker from "@/views/apps/PriceCategory/PriceCategoryPicker.vue";
import MasterPicker from "@/views/components/MasterActiveCourse/MasterPicker.vue";
import LoyaltyDiscountLevelPicker from "@/views/components/ScheduleLoyaltyDiscount/LoyaltyDiscountLevelPicker.vue";
import LanguagePicker from "@/views/components/Language/LanguagePicker.vue";
import DayOfWeekPicker from "@/views/components/Utils/DayOfWeekPicker.vue";
import GeneralLineChart from "@/views/dashboard/analytics/UserReport/GeneralLineChart.vue";
</script>